module.exports = __webpack_public_path__ + "static/img/2_4.35148fa4.jpg";